import { PropsWithChildren } from "react"
import "./generic-components.css"

export const ListTitle = ({ title }: { title: string }) => {
  return (
    <div className="flex">
      <h1 className="font-bold">{title}</h1>
    </div>
  )
}

export const Modal = ({
  isOpen,
  onClose,
  children,
  classNames,
}: PropsWithChildren<{ isOpen: boolean; onClose: () => void; classNames?: string }>) => {
  if (!isOpen) return null

  return (
    <div className="modal modal-open">
      <div className={`modal-box ${classNames}`}>{children}</div>
    </div>
  )
}

export const ModalHeader = ({ children }: PropsWithChildren) => {
  return <div className="text-lg font-bold">{children}</div>
}

export const ModalBody = ({ children }: PropsWithChildren) => {
  return <div className="py-4">{children}</div>
}

export const ModalFooter = ({ children }: PropsWithChildren) => {
  return <div className="modal-action">{children}</div>
}
